// var previouslyViewedNavigationImage = "";

// document.addEventListener("DOMContentLoaded", function() {
//   var navLinksWithDataHover = document.querySelectorAll("a[data-hover]"); 
//   var testImage = document.getElementById("navigation-hovering-img");

//   if (!testImage) return;

//   previouslyViewedNavigationImage = testImage.currentSrc || testImage.src || "";

//   navLinksWithDataHover.forEach(function(link) {
//     link.addEventListener("mouseover", function() {
//       var productHandle = this.getAttribute("data-hover");
//       var nextImage = switchExample(productHandle);

//       if (!nextImage) return;

//       testImage.src = nextImage;
//       previouslyViewedNavigationImage = nextImage;
//     });
//   });
// });

// function switchExample(input) {
//   switch (input) {
//     case "חברי-אורות-האהבה-מנורת-לילה-מנגנת-ומקליטה":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/lovelight.webp?v=1782394223";
//     case "רעש-לבן-לתינוקות-חברי-צלילי-ההרגעה":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/lionhome_1524x_e1b5d88f-656e-4780-9f2c-fc5792caff9f.webp?v=1782394223";
//     case "מנורות-ומקרנים-לנסיעות":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/0cb1b3a3-a3ff-4d72-9d37-2d7fe89a4b4a._CR0_0_500_500_SX460.webp?v=1782394224";
//     case "כל-המוצרים":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/menutopcb_1524x_e66e38ba-dc10-45fe-9897-ceff7e10bfd0.webp?v=1782394223";
//     case "החברים-הרגועים-מנורת-לילה-מנגנת-עם-מקרן":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/whalecoll2_407c26a1-8aea-4dae-8093-a1eccc0a43bc.webp?v=1782394223";
//     case "הצב-הרגוע":
//       return "https://cloudb.co.il/cdn/shop/files/DSC03253-Grande_ce298b04-62dd-4c05-bea0-875ba707f101_1.webp?v=1706897316";
//     case "הלוויתן-הרגוע":
//       return "https://cloudb.co.il/cdn/shop/files/3700552320089_41_-Grande_bf4a7ea1-51be-4db8-9eb2-626fde1fef41.jpg?v=1706644700";
//     case "חברי-אורות-האהבה-מנורת-לילה-מנגנת-ומקליטה":
//       return "https://cloudb.co.il/cdn/shop/collections/3700552320034_39_-_Grande_88b5f6f1-1c26-4113-b614-7f7bb5ae2a45_900x.webp?v=1682000642";
//     case "מקרן-כוכבים":
//       return "https://cloudb.co.il/cdn/shop/collections/starprojherader_900x.webp?v=1676389217";
//     case "צב-הדימדומים":
//       return "https://cloudb.co.il/cdn/shop/collections/7323-BL_lifestyle_14_-_Moyenne_720x.webp?v=1676633721";
//     case "צב-הדימדומים-המנצנץ":
//       return "https://cloudb.co.il/cdn/shop/collections/twinklecoll_720x.webp?v=1676635654";
//     case "חברי-הדימדומים":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/7473-BB_23.jpg?v=1708102641";
//     case "חיפושית-הדימדומים":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/lady.png?v=1708102618";
//     case "חברי-החלומות":
//       return "https://cloudb.co.il/cdn/shop/collections/dreamcoll_720x.webp?v=1682001124";
//     case "רעש-לבן-לתינוקות-חברי-צלילי-ההרגעה":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/7700-BD_52.jpg?v=1708102641";
//     case "צלילי-הרגעה-לדרך":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/Screenshot_2024-02-16_175408.png?v=1708102619";
//     case "חלומות-מתוקים":
//       return "https://cloudb.co.il/cdn/shop/collections/sweet-dreamz_720x.webp?v=1676633611";
//     case "מנצנצים-לדרך":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/7451-PK3_lifestyle_14_square.jpg?v=1707999023";
//     case "מנורות-ומקרנים-לנסיעות":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/togo.jpg?v=1707999521";
//     case "כל-המוצרים":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/image-5-3-3_1.jpg?v=1676639789";

//     case "lovelight™-buddies":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/lovelight.webp?v=1782394223";
//     case "sound-soothers":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/lionhome_1524x_e1b5d88f-656e-4780-9f2c-fc5792caff9f.webp?v=1782394223";
//     case "travel-sound-soothers":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/Screenshot_2024-02-16_175408.png?v=1708102619";
//     case "on-the-go":
//       return "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/0cb1b3a3-a3ff-4d72-9d37-2d7fe89a4b4a._CR0_0_500_500_SX460.jpg?v=1673789440";
//     case "shop-all":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/menutopcb_1524x_e66e38ba-dc10-45fe-9897-ceff7e10bfd0.webp?v=1782394223";
//     case "tranquil-family":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/whalecoll2_407c26a1-8aea-4dae-8093-a1eccc0a43bc.webp?v=1782394223";
//     case "tranquil-turtle™-rechargeable":
//       return "https://cloudb.co.il/cdn/shop/files/DSC03253-Grande_ce298b04-62dd-4c05-bea0-875ba707f101_1.webp?v=1706897316";
//     case "tranquil-whale™-family":
//       return "https://cloudb.co.il/cdn/shop/files/3700552320089_41_-Grande_bf4a7ea1-51be-4db8-9eb2-626fde1fef41.jpg?v=1706644700";
//     case "stars-projectors":
//       return "https://cloudb.co.il/cdn/shop/collections/starprojherader_900x.webp?v=1676389217";
//     case "twilight-turtle™":
//       return "https://cloudb.co.il/cdn/shop/collections/7323-BL_lifestyle_14_-_Moyenne_720x.webp?v=1676633721";
//     case "twinkling-twilight-turtles":
//       return "https://cloudb.co.il/cdn/shop/collections/twinklecoll_720x.webp?v=1676635654";
//     case "twilight-buddies":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/7473-BB_23.jpg?v=1708102641";
//     case "dream-buddies":
//       return "https://cloudb.co.il/cdn/shop/collections/dreamcoll_720x.webp?v=1682001124";
//     case "sweet-dreamz-on-the-go™":
//       return "https://cloudb.co.il/cdn/shop/collections/sweet-dreamz_720x.webp?v=1676633611";
//     case "twinkles-to-go-octo™":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/7451-PK3_lifestyle_14_square.jpg?v=1707999023";
//     case "owlie":
//       return previouslyViewedNavigationImage;
//     case "cloudbox™":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/cloudbox-screen_48db59cb-9af0-4e58-9fdb-56cb1e0190e0.webp?v=1782830963";
//     case "twilight-ladybug":
//       return "https://cdn.shopify.com/s/files/1/0677/0786/3357/files/lady_b890a7a6-db04-49a0-a0e6-f29fa451b6be.webp?v=1782830963";
//     case "tranquil-penguin™": 
//       return "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/9200-PG_4.jpg?v=1723879827";
//     case "tranquil-turtle™": 
//       return "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/turtelcollection.jpg?v=1673789702";

//     default:
//       return previouslyViewedNavigationImage;
//   }
// }

document.addEventListener("DOMContentLoaded", function() {
  // Image URLs to preload
  const imageUrls = {
    "tranquil-family": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/whalecoll2_407c26a1-8aea-4dae-8093-a1eccc0a43bc.jpg?v=1674134974",
    "tranquil-turtle™-rechargeable": "https://cloudb.com/cdn/shop/files/DSC03253-Grande_42952d1a-dd0d-4071-b1ec-5d81f451fd76.webp?v=1706301897",
    "tranquil-turtle™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/turtelcollection.jpg?v=1673789702",
    "tranquil-penguin™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/9200-PG_4.jpg?v=1723879827",
    "tranquil-whale™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/products/DSC03265-Moyenne_eaddc322-1aa7-403b-8d73-7df706fb993e.webp?v=1692972216",
    "stars-projectors": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/starprojherader.jpg?v=1674139823",
    "twilight-turtle™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/7323-BL_lifestyle_14_-_Moyenne.jpg?v=1674848533",
    "twinkling-twilight-turtles": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/twinklecoll.jpg?v=1673792654",
    "twilight-buddies": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/7473-BB_23.jpg?v=1708102130",
    "twilight-ladybug": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/lady.png?v=1708102032",
    "dream-buddies": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/dreamcoll.jpg?v=1673792428",
    "on-the-go": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/0cb1b3a3-a3ff-4d72-9d37-2d7fe89a4b4a._CR0_0_500_500_SX460.jpg?v=1673789440",
    "travel-sound-soothers": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/Screenshot_2024-02-16_175408.png?v=1708102480",
    "sweet-dreamz™": "https://cloudb.com/cdn/shop/collections/sweet-dreamz_1524x.jpg?v=1673790677",
    "twinkles-to-go": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/7451-PK3_lifestyle_14_square-1_e896fb1b-7c5d-4e3f-b9c3-fc945a9c6d79.jpg?v=1707401372",
    "sound-soothers": "https://cloudb.com/cdn/shop/collections/lionhome_1524x.jpg?v=1673771944",
    "lovelight™-buddies": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/lovelight.png?v=1708710651",
    "cloudbox™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/cloudbox-screen.png?v=1708711040",
    "shop-all": "https://cloudb.com/cdn/shop/files/menutopcb_1524x.jpg?v=1693901867"
  };

  // Preload images
  const preloadedImages = {};
  for (const key in imageUrls) {
    const img = new Image();
    img.src = imageUrls[key];
    preloadedImages[key] = img;
  }

  const testImage = document.getElementById("navigation-hovering-img");

  document.querySelectorAll("a[data-hover]").forEach(function(link) {
    link.addEventListener("mouseover", function() {
      const productHandle = this.getAttribute("data-hover");
      const image = preloadedImages[productHandle];
      if (image) {
        testImage.src = image.src;
      }
    });
  });
});
